import { useMutation } from '@tanstack/react-query';
import { axios } from '@/lib/axios/axios';
import { MESSAGING_API_BASE } from '../config';

export type RemoveMemberDTO = {
  channelId: number;
  userId: number;
};

const removeMember = async (
  data: RemoveMemberDTO
): Promise<{ success: boolean }> => {
  const { channelId, userId } = data;

  return axios.delete(
    `${MESSAGING_API_BASE}/channels/${channelId}/members/${userId}`
  );
};

export const useRemoveMember = () => {
  return useMutation({
    mutationFn: (data: RemoveMemberDTO) => removeMember(data),
  });
};
